import React, { useState, useEffect } from 'react';
import { DashboardApi } from '../../../apis/DashboardApi';
import { Search, UserPlus } from 'lucide-react';
import { AxiosResponse } from 'axios';
import Sidebar from '../../Sidebar/Sidebar';
import Navbar from '../../Navbars/UserNavbar';
import { NavLink } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

interface Recipient {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    temporaryUrl?: string;
    group: {
        name: string;
    };
    contact: {
        name: string;
    };
}

interface RecipientsByGroup {
    [key: string]: Recipient[];
}

const RecipientPage = () => {
    const [recipients, setRecipients] = useState<Recipient[]>([]);
    const [recipientGroup, setRecipientGroup] = useState<any>([]);
    const [recipientsByGroup, setRecipientsByGroup] = useState<RecipientsByGroup>({});
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedGroup, setSelectedGroup] = useState('');
    const sharedData = useSelector((state: any) => state.data.shared.value);
    const [recipientLength, setRecipientLength] = useState(sharedData?.data?.recipient_count);

    const userLoginData = useSelector((state: any) => state.data.login.value);
    

    React.useEffect(() => {
        DashboardApi.getRecipient().then(
            (response: AxiosResponse<any>) => {
                if (response?.data) {
                    setRecipients(response.data?.data)
                    // setRecipientLength(response?.data?.data?.length)
                    // Group recipients
                    const grouped = response.data?.data?.reduce((acc: RecipientsByGroup, recipient: Recipient) => {
                        const group = recipient.group.name;
                        if (!acc[group]) acc[group] = [];
                        acc[group].push(recipient);
                        return acc;
                    }, {});

                    setRecipientsByGroup(grouped);
                }
            }
        ).catch(function (error) {
            // handle error

        })


        DashboardApi.getRecipientGroup().then(
            (response: AxiosResponse<any>) => {
                if (response?.data) {
                    setRecipientGroup(response.data?.data)
                }
            }
        )





    }, []);


    const filteredRecipientsByGroup = React.useMemo(() => {
        if (!selectedGroup) return recipientsByGroup;

        return Object.entries(recipientsByGroup)
            .filter(([groupName]) => groupName === selectedGroup)
            .reduce((acc, [groupName, recipients]) => ({
                ...acc,
                [groupName]: recipients
            }), {});
    }, [recipientsByGroup, selectedGroup]);

    // const recipientsByGroup = recipients.reduce((acc: any, recipient: any) => {
    //     const group = recipient.group.name;
    //     if (!acc[group]) acc[group] = [];
    //     acc[group].push(recipient);
    //     return acc;
    // }, {} as Record<string, Recipient[]>);

    return (

        <div className="min-h-screen bg-white">
            <div className="flex flex-col md:flex-row">
                <Sidebar />
                <main className="flex-1 p-6 relative md:ml-64">
                    <Navbar />
                    <div className="p-6">
                        <div className="flex flex-col md:flex-row justify-between items-center mb-8">
                            <h1 className="text-2xl font-bold mb-4 md:mb-0">Recipients</h1>

                            <div className="flex flex-col md:flex-row gap-4 w-full md:w-auto">
                                <select
                                    className="p-2 border rounded-lg"
                                    value={selectedGroup}
                                    onChange={e => setSelectedGroup(e.target.value)}
                                >
                                    <option value="">All</option>
                                    {Object.keys(recipientsByGroup).map(group => (
                                        <option key={group} value={group}>{group}</option>
                                    ))}
                                </select>

                                {/* <select
                                    className="p-2 border rounded-lg"
                                    value={selectedStatus}
                                    onChange={e => setSelectedStatus(e.target.value)}
                                >
                                    <option value="">Status</option>
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                </select> */}

                                <div className="relative">
                                    <input
                                        type="search"
                                        placeholder="Search"
                                        className="pl-10 pr-4 py-2 border rounded-lg w-full"
                                        value={searchTerm}
                                        onChange={e => setSearchTerm(e.target.value)}
                                    />
                                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                                </div>

                                <NavLink to={recipientLength < userLoginData?.data?.user_data?.no_of_recipients ? '/add-recipient' : '/upgrade'} className="bg-orange-500 text-white px-4 py-2 rounded-lg flex items-center gap-2">
                                    <UserPlus size={20} />
                                    {(recipientLength < userLoginData?.data?.user_data?.no_of_recipients) ? 'Add Recipient' : 'Upgrade'}
                                </NavLink>
                            </div>
                        </div>

                        {Object.entries(filteredRecipientsByGroup as Record<string, Recipient[]>).length > 0 ? (
                            Object.entries(filteredRecipientsByGroup as Record<string, Recipient[]>).map(([groupName, groupRecipients]) => (
                                <div key={groupName} className="mb-12">
                                    <h2 className="text-xl font-semibold mb-6">{groupName}</h2>
                                    {groupRecipients.length > 0 ? (
                                        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-6 gap-6">
                                            {groupRecipients.map(recipient => (
                                                <NavLink
                                                    to={`/recipients/${recipient?.id}`}
                                                    key={recipient?.id}
                                                    className="flex flex-col  p-4"
                                                >
                                                    <img
                                                        src={recipient?.temporaryUrl || 'images/profile_image.jpg'}
                                                        alt={`${recipient?.first_name} ${recipient?.last_name}`}
                                                        className="w-24 h-24 rounded-full object-cover mb-4 border"
                                                    />
                                                    <h3 className="font-medium text-[10px]">{`${recipient?.first_name} ${recipient?.last_name}`}</h3>
                                                    <hr className='mr-10'/>
                                                    {/* <p className="text-gray-400 text-[10px]">{recipient?.group?.name}</p> */}
                                                    <p className="text-gray-600 text-[10px]">{recipient?.contact?.name}</p>
                                                </NavLink>
                                            ))}
                                        </div>
                                    ) : (
                                        <p className="text-gray-500">No recipients in this group</p>
                                    )}
                                </div>
                            ))
                        ) : (
                            <p className="text-gray-500 text-center mt-[40vh]">No Recipients</p>
                        )}

                    </div>
                </main>
            </div>
        </div>
    );
};

export default RecipientPage;